import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class PaymentWindowService {

  public showPaymentWindow(): void {
    window.parent.postMessage('SHOW_PAYMENT_WINDOW', '*');
  }

}
